import LayoutBanner from "@/components/customLayoutServices/LayoutBanner";
// import Dropdown from "@/components/infoWithDropdown/Dropdown";
interface Props {
  bannerSrc: string;
  cardTitle: string;
  children: React.ReactNode;
}
export default function LayoutTransporte({
  bannerSrc,
  cardTitle,
  children,
}: Props) {
  return (
    <main className="min-h-screen bg-[var(--fondo-auxiliar2)] relative">
      <LayoutBanner bannerSrc={bannerSrc} cardTitle={cardTitle}>
        <div className="w-[90%]">{children}</div>
      </LayoutBanner>
    </main>
  );
}
